module.exports = __webpack_public_path__ + "media/images/dcpl-7f241c78fcf77cf68ec42ddacb20fe8e.png";